// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from '@/App'
import router from '@/router/kyf/bg'
import fetchStore from '@/store/fitnes'
import { recipts } from '@/store/fitnes/modules/recipts/en'
import constants from '@/constants'
import workouts from '@/store/fitnes/modules/workoutsEN'
import i18n from '@/i18n'
import translations from '@/i18n/bg'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';


const isMH = false
const lang = 'bg'
const requireSaleID = false
const store = fetchStore(recipts, workouts, isMH, requireSaleID, constants.API_NTH, process.env.NODE_ENV !== 'production' ? constants.DEV_SERVER : constants.DEFAULT_SERVER)
Vue.config.productionTip = false
Vue.prototype.$scrollToTop = (n) => window.scrollTo(0,n === undefined ? 0 : n)
Vue.use(Loading)
i18n(Vue, store, translations, lang)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main/kyf/bg.js